/* Presentation only: Shopify Forms retains ownership of consent, validation,
   submission, discount display, timing, dismissal and the welcome-email trigger.
   The app currently exposes an open shadow root; no private APIs are called. */
(() => {
  const source = document.currentScript;
  const stylesheet = source && source.dataset.stylesheet;
  if (!stylesheet) return;
  const formId = source.dataset.formId;
  const selector = formId ? `shopify-forms-embed[id="app-embed-container-${formId}"]` : 'shopify-forms-embed';
  const roots = new WeakSet();

  function enhance(host) {
    const root = host.shadowRoot;
    if (!root) return;
    function attachStyles() {
      if (!root.querySelector('#app-embed[data-layout="overlay"]') || root.querySelector('#krew-popup-styles')) return;
      const link = document.createElement('link');
      link.id = 'krew-popup-styles';
      link.rel = 'stylesheet';
      link.href = stylesheet;
      root.append(link);
    }
    attachStyles();
    if (roots.has(root)) return;
    roots.add(root);
    // Reapply if Forms replaces its markup when moving between form/teaser/success.
    new MutationObserver(attachStyles).observe(root, { childList: true, subtree: true });
  }

  function scan() { document.querySelectorAll(selector).forEach(enhance); }
  scan();
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) scan();
  }).observe(document.documentElement, { childList: true, subtree: true });
  // A host can be inserted before its shadow root is ready. Stop polling once ready.
  let attempts = 0;
  const startup = setInterval(() => {
    scan();
    const hosts = [...document.querySelectorAll(selector)];
    if (++attempts >= 120 || (hosts.length && hosts.every(host => roots.has(host.shadowRoot)))) clearInterval(startup);
  }, 500);
})();
